import { actions } from './actions';
import { mutations } from './mutations';
import { Pagination } from 'packages/core/Pagination';
import { importCandidates } from './import';
import { exportCandidates } from './export';
var state = {
    candidates: [],
    loading: false,
    pagination: new Pagination(),
};
export var candidates = {
    state: state,
    namespaced: true,
    actions: actions,
    mutations: mutations,
    modules: {
        import: importCandidates,
        export: exportCandidates,
    },
};
